import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
export const CheckboxDropdownContext = /*#__PURE__*/React.createContext();
export function CheckboxDropdownProvider(props) {
  const {
    value,
    children
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValues, setSelectedValues] = useState([{}]);
  const checkboxDropdownRef = useRef(null);
  useEffect(() => {
    if (value.length) {
      if (JSON.stringify(value) !== JSON.stringify(selectedValues)) {
        setSelectedValues(value);
      }
    } else {
      setSelectedValues([{
        label: '',
        value: ''
      }]);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement(CheckboxDropdownContext.Provider, {
    value: {
      checkboxDropdownRef,
      isOpen,
      setIsOpen,
      selectedValues,
      setSelectedValues
    }
  }, children);
}
CheckboxDropdownProvider.propTypes = {
  value: PropTypes.array.isRequired,
  children: PropTypes.node.isRequired,
  placeHolder: PropTypes.string.isRequired
};